import React from 'react';

// Utils
import withSidebar from '../utils/hocs/withSidebar';
import withAuth from '../utils/hocs/withAuth';
import buildTabs from '../utils/tools/buildTabs';

// Icons
import { ReactComponent as FileIcon } from '../assets/icons/file.svg';
import { ReactComponent as ToolsIcon } from '../assets/icons/tools.svg';

// Components
import PageWrapper from '../components/layout/PageWrapper/PageWrapper';
import General from '../components/views/establishment/Establishment/General/General';
import Equipments from '../components/views/establishment/Establishment/Equipments/Equipments';
import LayoutWithTabs from '../components/layout/LayoutWithTabs/LayoutWithTabs';

function Establishment() {
  const tabs = buildTabs([
    {
      label: 'establishment.tabs.general',
      component: <General />,
      icon: <FileIcon />,
    },
    {
      label: 'establishment.tabs.equipments',
      component: <Equipments />,
      icon: <ToolsIcon />,
    },
  ]);

  return (
    <PageWrapper>
      <LayoutWithTabs
        tabs={tabs}
      />
    </PageWrapper>
  );
}

export default withAuth(
  withSidebar(Establishment, { withTabsBar: true }),
);
